import React from "react";

export default function Gems({ gems, bg }) {
    return (
        <div
            className={`flex flex-wrap gap-2 justify-center items-center ${!bg ? 'bg-gray-900' : bg}  rounded-lg p-4 overflow-auto`}
            style={{ maxHeight: '300px' }}
        >
            {gems.map((gem, index) => (
                <div
                    key={index}
                    className="flex flex-col items-center justify-center w-10 h-10 bg-gray-800 rounded-md shadow-md"
                >
                    {/* Гем или "out" версия */}
                    <img
                        src={gem.count > 0 ? gem.icon : gem.outIcon}
                        alt={gem.name}
                        className="w-6 h-6"
                    />

                    {/* Количество */}
                    <span className="text-[10px] font-semibold text-gray-200 mt-1">
                        {gem.count}
                    </span>
                </div>
            ))}
        </div>
    );
}
